<template>
  <!-- 友情链接栏 -->
  <div id="footerLinks" style="background: #141B2D; display: flex; align-items: center; gap: 0; padding: 10px 40px; flex-wrap: wrap;">
    <span style="background: #C41E3A; color: white; padding: 5px 14px; border-radius: 3px; font-size: 13px; white-space: nowrap; margin-right: 20px; flex-shrink: 0;">友情链接</span>
    <a href="http://39.105.114.210:13309/" target="_blank" style="color: rgba(255,255,255,0.75); text-decoration: none; font-size: 13px; white-space: nowrap; padding: 0 16px; border-right: 1px solid rgba(255,255,255,0.2); transition: color 0.3s;" onmouseover="this.style.color='#fff'" onmouseout="this.style.color='rgba(255,255,255,0.75)'">河南国资科教产融创新平台</a>
  </div>

  <!-- 顶部信息栏 -->
  <div class="footer-top">
    <div class="footer-container">
      <div class="footer-info-item">
        <svg class="footer-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="3" y="5" width="14" height="10" rx="1" stroke="#00B8DB " stroke-width="1.5"/>
          <path d="M3 7l7 5 7-5" stroke="#00B8DB " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>邮箱：hnskjcxgs@163.com</span>
      </div>
      <div class="footer-info-item">
      <svg t="1771061455580" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="26699" width="32" height="32"><path d="M689.654 755.164c-8.746 3.416-18.604-0.904-22.02-9.65-3.416-8.745 0.904-18.604 9.65-22.02 9.164-3.58 17.731-8.434 25.094-14.2 0.7-0.548 1.431-1.034 2.187-1.457l17.328-16.965c8.248-8.33 8.463-21.306 0.912-28.881l-71.99-71.995c-7.604-7.574-20.617-7.332-28.92 0.972l-36.276 36.27a17 17 0 0 1-20.21 2.876c-2.183-1.2-4.521-2.5-7.21-4.006-18.55-10.277-28.384-16.07-41.156-24.739-17.566-11.924-33.99-25.318-49.886-41.223-15.936-15.936-29.35-32.391-41.298-49.993-8.669-12.769-14.377-22.455-24.8-41.226-2.14-3.874-2.79-5.042-3.772-6.755a17 17 0 0 1 2.735-20.487l24.336-24.3 11.976-11.986c8.315-8.318 8.548-21.31 0.965-28.904l-72.007-72.023c-7.572-7.572-20.576-7.33-28.861 0.96l-16.698 16.795c-0.481 0.927-1.054 1.82-1.719 2.67-5.765 7.353-10.614 15.894-14.24 25.128-3.38 8.92-5.463 17.325-6.409 25.707-8.78 72.768 24.953 140.249 119.395 234.697 38.791 38.79 77.455 67.453 115.381 87.327 25.777 13.506 50.206 22.421 72.946 27.543 9.16 2.062 14.913 11.16 12.85 20.32-2.063 9.159-11.16 14.912-20.32 12.849-25.608-5.767-52.832-15.703-81.256-30.596-41.012-21.49-82.451-52.21-123.642-93.402-101.068-101.072-139.36-177.65-129.132-262.616 1.278-11.28 4.057-22.454 8.431-33.98 4.216-10.76 9.607-20.724 16.029-29.675a16.934 16.934 0 0 1 3.978-6.326l20.327-20.446c21.4-21.408 55.926-22.052 76.982-0.995l72.016 72.031c21.044 21.074 20.426 55.57-0.967 76.97l-11.987 11.998-15.252 15.23c8.48 15.18 13.552 23.651 20.845 34.397 10.785 15.887 22.849 30.686 37.213 45.05 14.322 14.33 29.087 26.371 44.937 37.13 10.76 7.304 19.356 12.444 34.508 20.89l27.207-27.203c21.376-21.375 55.871-22.019 76.98-0.994l72.033 72.038c21.013 21.082 20.39 55.57-0.964 76.976l-20.705 20.274a16.952 16.952 0 0 1-5.556 3.63c-9.09 6.593-19.247 12.12-29.988 16.315z" fill="#00B8DB" p-id="26700"></path></svg>
        <span>电话：0371-60569125</span>
      </div>
      <div class="footer-info-item">
<svg t="1771061533749" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31084" width="16" height="16"><path d="M895.8 446.6V184.5c0-66.9-53.7-121.2-119.6-121.2H248.9c-65.9 0-119.6 54.4-119.6 121.2v261.7c-37.8 12.2-65.1 47.6-65.1 89.5v330c0 51.9 42.1 94 94 94h707.1c51.9 0 94-42.1 94-94v-330c0-41.4-26.6-76.4-63.5-89.1zM248.9 133.2h527.2c27.3 0 49.6 23 49.6 51.2v277.3L513 621.6 199.3 462.5v-278c0-28.3 22.3-51.3 49.6-51.3z m640.4 732.4c0 13.2-10.8 24-24 24H158.2c-13.2 0-24-10.8-24-24v-330c0-9.2 5.2-17.2 12.8-21.2L481.3 684l31.8 16.1 31.7-16.2 331.8-169.5c7.6 4 12.7 12 12.7 21.2v330z" p-id="31085" fill="#00B8DB"></path></svg>
        <span>邮编：450018</span>
      </div>
      <div class="footer-info-item">
        <svg class="footer-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 2C7.5 2 5 4 5 7c0 4 5 9 5 9s5-5 5-9c0-3-2.5-5-5-5z" stroke="#00B8DB " stroke-width="1.5"/>
          <circle cx="10" cy="7" r="2" stroke="#00B8DB " stroke-width="1.5"/>
        </svg>
        <span>地址：河南省郑州市金水区如意西路93号10楼</span>
      </div>
    </div>
  </div>



  <!-- 底部版权栏 -->
  <div class="footer-bottom">
    <div class="footer-container">
      <div class="footer-copyright">
        <span>© 2024 HENAN SCI-TECH INNOVATION PLATFORM. ALL RIGHTS RESERVED.</span>
      </div>
      <div class="footer-links">
        <span class="footer-text">河南省科教创新科技成果转化服务有限公司</span>
        <a href="http://beian.miit.gov.cn/" target="_blank" class="footer-link">
          豫ICP备2025152091号-1
        </a>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41010502006603" target="_blank" class="footer-link">
          <img src="../assets/img/gh.png" alt="公安备案" class="footer-icon-small">
          豫公网安备41010502006603号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FootBut'
}
</script>

<style scoped>
.footer-top {
  width: 100%;
  height: 96px;
  background: #020617;
  border: 1px solid rgba(28, 57, 142, 0.3);
  border-radius: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-bottom {
  width: 100%;
  background-color: #010203;
  padding: 20px 0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6B7280;
  font-family: 'Source Han Sans', sans-serif;
  white-space: nowrap;
}

.footer-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.footer-copyright {
  font-size: 12px;
  color: #4B5563;
  font-family: 'Source Han Sans', sans-serif;
  letter-spacing: 0.5px;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-text {
  font-size: 13px;
  color: #6B7280;
  font-family: 'Source Han Sans', sans-serif;
}

.footer-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6B7280;
  text-decoration: none;
  transition: color 0.3s;
  font-family: 'Source Han Sans', sans-serif;
}

.footer-link:hover {
  color: #3B82F6;
}

.footer-icon-small {
  width: 16px;
  height: 18px;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-container {
    gap: 15px;
    justify-content: flex-start;
  }

  .footer-info-item {
    font-size: 12px;
  }

  .footer-copyright,
  .footer-link {
    font-size: 12px;
  }

  .footer-links {
    gap: 15px;
  }
}
</style>

